import { Component, OnInit } from '@angular/core';
import { AuthserviceService } from 'src/app/services/authservice.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { UndefinedNullableString } from 'src/app/type-alias';
import { Router } from '@angular/router';
import { AppSessionStorageService } from 'src/app/services/utils/session-storage.service';
import { ErrorMessageConstants } from 'src/app/constants/error-message-constants';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.css',
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm = new FormGroup({
    currentPassword: new FormControl('', [
      Validators.required,
      Validators.minLength(8),
    ]),
    newPassword: new FormControl('', [
      Validators.required,
      Validators.minLength(8),
    ]),
    reTypePassword: new FormControl('', [
      Validators.required,
      Validators.minLength(8),
    ]),
  });
  isSubmitting: boolean = false;
  errorString: UndefinedNullableString;
  passwordLengthMessage: string =
    'Password should contain atleast 8 character.';
  constructor(
    private authService: AuthserviceService,
    private router: Router
  ) {}
  ngOnInit(): void {
    AppSessionStorageService.sideBarSelection = 2
    this.userDetails();
  }
  get profileImage(): string {
    return this.authService.getUserImage() ?? 'assets/default-image.svg';
  }

  async userDetails() {
    if (!AppSessionStorageService.user) {
      await this.authService.fetchUserDetails();
    }
  }

  get currentPassword() {
    return this.changePasswordForm.get('editedFirstName');
  }

  get newPassword() {
    return this.changePasswordForm.get('editedLastName');
  }

  get reTypePassword() {
    return this.changePasswordForm.get('editedLastName');
  }
  async onSubmit() {
    this.errorString = '';
    if (!this.isSubmitting) {
      this.isSubmitting = true;
    }
    try {
      const currentPassword =
        this.changePasswordForm.get('currentPassword')!.value;
      const newPassword = this.changePasswordForm.get('newPassword')!.value;
      const reTypePassword =
        this.changePasswordForm.get('reTypePassword')!.value;
      if (!this.emptyFieldCheck()) {
        return;
      }
      if (!this.changePasswordForm.valid) {
        this.errorvalidator();
        return;
      }
      if (
        !this.passwordRegexCheck(newPassword, reTypePassword) ||
        !this.newPasswordMatch(newPassword, reTypePassword)
      ) {
        return;
      }
      const payload = {
        current_password: currentPassword,
        new_password: newPassword,
      };
      const response = await this.authService.changePassword(payload);
      if(response?.success){
        this.errorString = "Password changed successfully"
        setTimeout(() => {
          this.profileView() 
        }, 1000); 
      }
      else{
        this.errorString = response?.error
      }
    } catch (_) {
      this.errorString = ErrorMessageConstants.SOMETHING_WRONG;
    }
    this.isSubmitting = false;
  }

  errorvalidator() {
    // Check if currentPassword has minlength error
    if (this.changePasswordForm.get('currentPassword')?.hasError('minlength')) {
      this.errorString = this.passwordLengthMessage;
      return;
    }
    // Check if newPassword has minlength error
    if (this.changePasswordForm.get('newPassword')?.hasError('minlength')) {
      this.errorString = this.passwordLengthMessage;
      return;
    }
    // Check if reTypePassword has minlength error
    if (this.changePasswordForm.get('reTypePassword')?.hasError('minlength')) {
      this.errorString = this.passwordLengthMessage;
      return;
    }
    this.errorString = 'Invalid request';
  }

  emptyFieldCheck() {
    const currentPassword =
      this.changePasswordForm.get('currentPassword')!.value;
    const newPassword = this.changePasswordForm.get('newPassword')!.value;
    const reTypePassword = this.changePasswordForm.get('reTypePassword')!.value;
    if (!currentPassword || !newPassword || !reTypePassword) {
      this.errorString = 'Fields cannot be empty';
      return false;
    }
    return true;
  }

  passwordRegexCheck(newPassword: any, reTypePassword: any) {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#&%!~$^_*])[a-zA-Z\d@#&%!~$^_*]{8,}$/;
    if (!regex.test(newPassword) || !regex.test(reTypePassword)) {
      this.errorString =
        'Password should be at least 8 characters which contains at least one lowercase,one uppercase,' +
        'one digit and at least one character from the set @#&%!~`$^_*';
      return false;
    }
    return true;
  }

  newPasswordMatch(newPassword: any, reTypePassword: any) {
    if (newPassword != reTypePassword) {
      this.errorString = 'Password mismatch';
      return false;
    }
    return true;
  }

  profileView() {
    AppSessionStorageService.grantAccess = null;
    if (AppSessionStorageService?.auth?.role == 'installer') {
      this.router.navigate(['installer/profile']);
    } else if (AppSessionStorageService?.auth?.role == 'administrator') {
      this.router.navigate(['admin/profile']);
    }
  }
}
